import React, { Component } from 'react';

import { Button } from '@bit/evidation.sdf1.studies.form-elements';
import CuriousPanda from './CuriousPanda';
import Modal from './modal';
import PropTypes from 'prop-types';
import { STUDY_ID } from '../constants';
import _ from 'lodash';
import api from '../services';
import { connect } from 'react-redux';
import detector from 'detector';

class ContactModal extends Component {
  constructor(props) {
    super(props);

    const participant = api.localStorage.get();

    this.state = {
      message: ``,
      header: props.contact_modal_heading,
      preferredMethod: props.contact_preferred_method,
      loading: false,
      participant,
    };
    this.submit = this.submit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ isShowingModal: false, message: ``, loading: false });
    this.props.onClose();
  }

  submit(data) {
    const { participant } = this.state;
    const participant_auth_token = _.has(participant, `participant_auth_token`)
      ? participant.participant_auth_token
      : ``;

    const payload = {
      ...participant,
      ...data,
      study_slug: STUDY_ID,
      client_info: detector,
    };

    this.setState({ loading: true }, () => {
      api.triage
        .post(`support_requests`, payload, participant_auth_token)
        .then(({ data }) => {
          this.setState({
            isShowingModal: true,
            header: data.success ? `Thanks!` : `There was a problem`,
            message: data.success
              ? `We'll contact you as soon as we can`
              : data.error || data.message || `An unknown error occurred`,
          });
        });
    });
  }

  render() {
    const {
      preferredMethod,
      header,
      message,
      isShowingModal,
      loading,
    } = this.state;
    const {
      children,
      contact_phone_number,
      contact_modal_message,
      contact_modal_heading,
    } = this.props;

    const form = [
      {
        input: [
          {
            name: 'email',
            label: 'Email Address',
            inputStyle: `achievement`,
            interface: 'email',
            required: true,
          },
          {
            inputStyle: `achievement`,
            name: 'request_content',
            label: 'Describe Your Request',
            interface: 'textarea',
            required: true,
          },
        ],
      },
    ];

    const initialValues = {
      email: _.has(this.state.participant, `email`)
        ? this.state.participant.email
        : ``,
    };

    return (
      <Modal
        label={children}
        header={`${message === `` ? contact_modal_heading : header}`}
        isShowingModal={isShowingModal}
        handleClose={this.handleClose}
      >
        {message === `` && (
          <div>
            <p className="text-center mb20">{contact_modal_message}</p>
            <div name="contactForm" className="multiple-choice">
              {preferredMethod &&
                contact_phone_number !== `` && (
                  <fieldset className="mb20">
                    <div className="text-small">
                      Your Preferred Contact Method
                    </div>
                    <div className="mt20 mb20 button--group">
                      <div className="float-left w50p">
                        <button
                          className={`button--hollow ${
                            preferredMethod === `Email` ? `active` : ``
                          }`}
                          onClick={() =>
                            this.setState({
                              preferredMethod: `Email`,
                              isShowingModal: true,
                            })
                          }
                        >
                          Email
                        </button>
                      </div>
                      <div className="float-right w50p">
                        <button
                          className={`button--hollow ${
                            preferredMethod === `Phone` ? `active` : ``
                          }`}
                          onClick={() =>
                            this.setState({
                              preferredMethod: `Phone`,
                              isShowingModal: true,
                            })
                          }
                        >
                          Phone
                        </button>
                      </div>
                    </div>
                  </fieldset>
                )}
              <div className="clear" />
              {preferredMethod === `Phone` && (
                <h2 className="text-center mb20">
                  Call {contact_phone_number} to contact our phone support
                </h2>
              )}
              {preferredMethod === `Email` && (
                <CuriousPanda
                  form="contact_us"
                  onSubmit={this.submit}
                  schema={form}
                  initialValues={initialValues}
                >
                  {({ valid, pristine, submitting }) => {
                    // Logic to determine if submit should be deactivated
                    // in this instance we are checking to see if we have initial values defined
                    // as If we have already populated the form (for CRF ONLY), it is ready to be submitted
                    // most other cases do not require this.
                    const allowSubmit =
                      !valid ||
                      submitting ||
                      (_.isEmpty(initialValues) && pristine);

                    return (
                      <Button
                        isLoading={submitting || loading}
                        buttonStyle="achievement"
                        id="t-submit_button"
                        type="submit"
                        disabled={allowSubmit}
                      >
                        Send Request
                      </Button>
                    );
                  }}
                </CuriousPanda>
              )}
            </div>
          </div>
        )}
        {message !== `` && <p className="text-center mb20">{message}</p>}
      </Modal>
    );
  }
}

ContactModal.defaultProps = {
  contact_modal_heading: `Need help? Get in touch.`,
  contact_phone_number: ``,
  contact_preferred_method: `Email`,
  contact_modal_message: `If you have questions or run into any issues during the study, please contact us. We're here to help!`,
  onClose: () => {},
};

ContactModal.propTypes = {
  onClose: PropTypes.func,
  contact_phone_number: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default connect(
  ({ meta }) => ({ ...meta }),
  null,
)(ContactModal);



// WEBPACK FOOTER //
// ./src/components/contactModal.js